
import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import AlertError from 'material-ui/svg-icons/alert/error';
import * as colors from 'material-ui/styles/colors';
import CircularProgress from 'material-ui/CircularProgress'

export default class ActivateLocationDialog extends React.Component {

  requiredFields = ["omnivoreId"];

  constructor(props) {
    super(props)
    this.state = {
      omnivoreId: '',
      activationError: ''
    }

    this.onSubmit = this.onSubmit.bind(this);
  }
  componentWillReceiveProps(newProps){
    this.setState({
      activationError: newProps.activationError
    })
  }

  handleClose = () => {
    if (this.props.closeDialog){
      this.props.closeDialog();
    }
  };

  onSubmit() {
    let updatedState = {};
    let foundError = false;
    this.requiredFields.forEach(f=> {
      updatedState[`${f}ValidationError`] =  !this.state[f]? 'Required' : '';
      foundError = foundError || !this.state[f];
    });

    if (!foundError){
      console.log('Submitting data',{loc: this.props.location._id, omnivore: this.state.omnivoreId});
      this.props.onSubmit(this.props.location._id, this.state.omnivoreId);
    } else {
      this.setState(updatedState);
    }

  }


  render() {

    let activationCompleted = this.props.location.systemType? true: false;

    const actions = [
      <FlatButton
        label={activationCompleted? "Close" : "Cancel"}
        primary={false}
        keyboardFocused={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.onSubmit}
      />,
    ];

    //don't need submit button if it's already activated.
    if (activationCompleted) {
      actions.pop()
    };

    return (
      <Dialog
          title='Activate with Omnivore'
          actions={actions}
          modal={true}
          open={this.props.show}
          onRequestClose={this.onClose}
      >
        
        {activationCompleted ?
           <div style={{textAlign: 'center'}}> <CheckCircle color={colors.green500} style={{height: 110, width: 110}} /> </div> 
          : 
          this.props.loading? 
            <div style={{textAlign: 'center'}}> 
              <CircularProgress/>
            </div> 
            :
            this.state.activationError? 
              <div style={{textAlign: 'center'}}> 
                <AlertError color={colors.red500} style={{height: 110, width: 110}} />
                <br/>
                <p style={{color: colors.red500}}>{this.state.activationError}</p>
               </div> 
              : 
              <TextField
                floatingLabelText="Omnivore Location Id" 
                value={this.state.omnivoreId} 
                onChange={(e)=> this.setState({omnivoreId: e.target.value})}
                errorText={this.state.omnivoreIdValidationError}
              />
        }<br/>
      </Dialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Locations/ActivateLocationDialog.js